import { Settings } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useColumnVisibility } from '@/hooks/useColumnVisibility';
import { useAuth } from '@/auth';
import { hasColumnPermission } from '@/contexts/ColumnVisibilityContext';

export const ColumnToggle = () => {
  const { columns, toggleColumn, resetColumns } = useColumnVisibility();
  const { user } = useAuth();
  const userPermissions = user?.permissions || [];

  // Filter out columns that require permissions the user doesn't have
  const availableColumns = columns.filter(column => hasColumnPermission(userPermissions, column));

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline">
          <Settings className="h-4 w-4" />
          <span className="ml-2 hidden sm:inline">Columnas</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        <DropdownMenuLabel>Mostrar columnas</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {availableColumns.map((column) => (
          <DropdownMenuCheckboxItem
            key={column.key}
            className="capitalize"
            checked={column.visible}
            onCheckedChange={() => toggleColumn(column.key)}
          >
            {column.label}
          </DropdownMenuCheckboxItem>
        ))}
        <DropdownMenuSeparator />
        <DropdownMenuCheckboxItem
          checked={false}
          onCheckedChange={resetColumns}
          className="text-sm text-muted-foreground"
        >
          Restaurar predeterminado
        </DropdownMenuCheckboxItem>
      </DropdownMenuContent>
    </DropdownMenu >
  );
};